import { gql } from '@apollo/client';

export const GET_AGENT_DETAILS = gql`
  query getAgentDetails($data: AgentDetailsInputType!) {
    response: get_agent_details(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GEN_SHOPIFY_INTEGRATION_CODE = gql`
  mutation genShopifyIntegrationCode(
    $input: GenShopifyIntegrationCodeInputType!
  ) {
    response: gen_shopify_integration_code(data: $input) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_SKIP_SHOPIFY = gql`
  mutation updateSkipShopify($input: UpdateSkipShopifyInputType!) {
    response: update_skip_shopify(data: $input) {
      hasError
      data
      message
    }
  }
`;

export const GET_CHANNELS = gql`
  query GetChannels {
    list_channels {
      hasError
      message
      data {
        _id
        agent_id
        messaging_product
        whatsapp_number
        created_at
      }
    }
  }
`;
